import type { RohsComponentComplianceFileDetailView } from '@/shared/hooks/api/rohsComplianceFiles'

export function isRohsTestReportAuditStale(
  file: RohsComponentComplianceFileDetailView
): boolean {
  const testSlot = file.slots.find((slot) => slot.slotKind === 'TEST_REPORT')
  if (testSlot?.uploadedAt == null || testSlot.fileName == null) {
    return false
  }
  const latest = file.latestTestReportAudit
  if (latest == null) {
    return true
  }
  if (latest.fileName !== testSlot.fileName) {
    return true
  }
  return new Date(testSlot.uploadedAt) > new Date(latest.timestamp)
}
